import globalAxios, { AxiosInstance, AxiosResponse } from "axios";
import { Configuration } from "../api-client";

/**
 * Hand-written client for the backend `maintenance` module.
 *
 * The OpenAPI client (src/api-client) is regenerated from the API's swagger.json
 * via `npm run generate-client`. Until that is regenerated, this thin client
 * provides the same surface so it can be wired through ApiProvider/useApi like
 * the generated clients. Methods return AxiosResponse so createProxiedClient can
 * unwrap `.data`. Once the swagger is regenerated, this can be swapped for the
 * generated `MaintenanceApi`.
 */

export interface MaintenanceUtilityDto {
  id: string;
  name: string;
  description: string;
  canRepair: boolean;
  destructive: boolean;
}

export interface MaintenanceCheckResultDto {
  id: string;
  count: number;
  sampleIds: string[];
  message: string;
}

export interface MaintenanceRepairResultDto {
  id: string;
  repaired: number;
  message: string;
}

export class MaintenanceApi {
  private readonly basePath: string;

  constructor(
    private readonly configuration?: Configuration,
    private readonly axios: AxiosInstance = globalAxios
  ) {
    this.basePath =
      configuration?.basePath || process.env.REACT_APP_API_URL || "";
  }

  private async authConfig() {
    const accessToken = this.configuration?.accessToken;
    const token =
      typeof accessToken === "function" ? await accessToken() : accessToken;
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
  }

  async listMaintenanceUtilities(): Promise<AxiosResponse<MaintenanceUtilityDto[]>> {
    return this.axios.get(`${this.basePath}/maintenance/utilities`, await this.authConfig());
  }

  async runMaintenanceCheck(id: string): Promise<AxiosResponse<MaintenanceCheckResultDto>> {
    return this.axios.post(
      `${this.basePath}/maintenance/utilities/${encodeURIComponent(id)}/check`,
      undefined,
      await this.authConfig()
    );
  }

  async runMaintenanceRepair(id: string): Promise<AxiosResponse<MaintenanceRepairResultDto>> {
    return this.axios.post(
      `${this.basePath}/maintenance/utilities/${encodeURIComponent(id)}/repair`,
      undefined,
      await this.authConfig()
    );
  }
}
